import request from '../request'

//修改个人信息
export function update(params) {
  return request({ url: '/api/MemberUser/update',method: 'post',data: params})
}
//重置密码
export function resetPwd(params) {
  return request({ url: '/api/MemberUser/resetPwd',method: 'post',data: params})
}
//获取自己的购卡记录
export function Financial_Vippay_index(params) {
  return request({ url: '/api/Financial.Vippay/index',method: 'post',data: params})
}
//根据卡ID获取未激活的卡密
export function activeListNo(params) {
  return request({ url: '/api/Financial.Vippay/activeListNo',method: 'post',data: params})
}
//激活卡密
export function cardActive(params) {
  return request({ url: '/api/Financial.Vippay/cardActive',method: 'post',data: params})
}
//获取自己的激活记录
export function activeRecord(params) {
  return request({ url: '/api/Financial.Vippay/activeRecord',method: 'post',data: params})
}
//入账明细
export function ruzhangList(params) {
  return request({ url: '/api/Financial.Vippay/ruzhangList',method: 'post',data: params})
}
//消费明细
export function zhichuRecord(params) {
  return request({ url: '/api/Financial.Vippay/zhichuRecord',method: 'post',data: params})
}
//提现明细
export function Withdraw_index(params) {
  return request({ url: '/api/Financial.Withdraw/index',method: 'post',data: params})
}
//支付宝提现
export function withdraw_deposit(params) {
  return request({ url: '/api/Alipay/withdraw_deposit',method: 'post',data: params})
}
//微信提现
export function wxTixian(params) {
  return request({ url: '/api/WxPay/wxTixian',method: 'post',data: params})
}
//获取自己的下级会员
export function getXiajiList(params) {
  return request({ url: '/api/MemberUser/getXiajiList',method: 'post',data: params})
}




// WEBPACK FOOTER //
// ./src/api/gw/user.js